import { useEffect, useRef } from 'react';

import { useSavedInRef } from './useSavedInRef';

export const useElementEvent = (
    target: EventTarget | null,
    event: string,
    callback: (e: Event | undefined) => void,
    runImmediately: boolean,
    addOptions: boolean | AddEventListenerOptions | undefined = undefined,
    when: boolean = true,
) => {
    const addOptionsRef = useRef(addOptions);
    const callbackRef = useSavedInRef(callback);

    useEffect(() => {
        if (!when || !target) return;

        const handler = (e: Event) => {
            callbackRef.current?.(e);
        };

        // Add event listener
        target.addEventListener(event, handler, addOptionsRef.current);

        // Call handler right away so state gets updated with initial window size
        if (runImmediately) {
            callbackRef.current?.(undefined);
        }
        // Remove event listener on cleanup
        return () => {
            target?.removeEventListener(event, handler);
        };
    }, [when, target, event, runImmediately, callbackRef]);
};
